import { SimpleFileLink } from '@texas/api/endpoints/filesApi';
import { httpClient } from '@texas/api/httpClient/httpClient';

export enum ComplianceDocumentKind {
  Certificate = 1,
  Report = 2,
}

export enum ComplianceDocumentType {
  Scoped = 1,
  Transactional = 2,
}

export interface ComplianceDocumentDefinition {
  id: number;
  name: string;
  description: string;
  kind: ComplianceDocumentKind;
  type: ComplianceDocumentType;
  archived: string | null;
  logo: SimpleFileLink | null;
}

export interface ComplianceDocumentDefinitionRequest {
  name: string;
  description: string;
  kind: ComplianceDocumentKind;
  type: ComplianceDocumentType;
  logoFileId: number | null;
}

export interface ComplianceDocumentDefinitionSearchQuery {
  searchTerm: string;
  includeArchived: boolean;
  sortBy: string;
  sortDesc: boolean;
}

export const complianceDocumentDefinitionsApi = {
  getAll: (params: ComplianceDocumentDefinitionSearchQuery) =>
    httpClient.get<ComplianceDocumentDefinition[]>(
      'metadata/compliance-document-definitions',
      {
        params,
      },
    ),
  create: (request: ComplianceDocumentDefinitionRequest) =>
    httpClient.post<ComplianceDocumentDefinition>(
      'metadata/compliance-document-definitions',
      {
        data: request,
      },
    ),
  update: (id: number, request: ComplianceDocumentDefinitionRequest) =>
    httpClient.put<ComplianceDocumentDefinition>(
      `metadata/compliance-document-definitions/${id}`,
      {
        data: request,
      },
    ),
  archive: (id: number) =>
    httpClient.put(`metadata/compliance-document-definitions/${id}/archive`),
  restore: (id: number) =>
    httpClient.put(`metadata/compliance-document-definitions/${id}/restore`),
};
